<template>
  <div class="business-card-box">
      <div class="content-container">
          <div class="business-card-content">
              <div class="business-card-template">
                  <div class="business-card-template-header">
                      <div class="search-box"></div>
                      <div class="operation-box">
                          <el-button type="primary" @click="openBusinessCardTemplate">添加模板</el-button>
                      </div>
                  </div>
                  <div class="business-card-template-content">
                      <el-table
                        :data="tableData"
                        height="calc(100vh - 175px)"
                        style="width: 100%"
                        @row-click="clickTr"
                        >
                        <el-table-column
                            prop="name"
                            label="模板名称"
                            width="">
                        </el-table-column>
                        <el-table-column
                            prop="memberNum"
                            label="员工人数"
                            width="">
                        </el-table-column>
                        <el-table-column
                            prop="askBotName"
                            label="关联智能助理"
                            width="">
                        </el-table-column>
                        <el-table-column
                            label="修改时间"
                            width="">
                            <template slot-scope="scope">
                                <p>{{ new Date(scope.row.updateTime).Format('yyyy-MM-dd hh:mm:ss') }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="200"
                            label="操作"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <!--<el-button size="mini" @click="onTemplateEdit(scope.row)" type="primary" icon="el-icon-edit" circle></el-button>
                                <el-button size="mini" @click.native.prevent="deleteTemplate(scope.row.id)" type="danger" icon="el-icon-delete" circle></el-button>-->
                                <el-button size="small" @click="notifyUser(scope.row)" type="text">通知模板使用者</el-button>
                                <el-button size="small" @click="onTemplateEdit(scope.row)" type="text">编辑</el-button>
                                <el-button size="small" @click.native.prevent="deleteTemplate(scope.row.id)" type="text">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                  </div>
              </div>
              
          </div>
      </div>
      <!-- 配置模板 -->
      <el-drawer
        :title="cardTitle"
        :visible.sync="templateConfigDrawer"
        direction="rtl"
        custom-class="demo-drawer"
        size="70%">
        <div class="template-config-content">
            <div class="business-card-template-config">
                  <div class="business-card-template-config-title">
                      <span>名片配置</span>
                  </div>
                  <div class="business-card-template-config-content">
                      <el-form ref="form" :model="businessCardTemplate" label-width="80px">
                        <el-form-item label="模板名称">
                            <el-input v-model="businessCardTemplate.name" placeholder="请输入模板名称"></el-input>
                        </el-form-item>
                        <el-form-item label="选择员工">
                           <!-- <el-cascader
                            v-model="businessCardTemplate.memberIdList"
                            :options="members"
                            :props="{multiple:true,emitPath:false,value:'id',label:'name',children:'children'}"
                            collapse-tags
                            clearable></el-cascader>-->
                            <div
                                    class="bind-bot-self-tree-box"

                            >
                                <div
                                        @click.stop="setActiveTreeIndex"
                                        :class="['selected-box']"
                                >
                                    <div class="tag-box">
                                        <span class="placeholder" v-if="businessCardTemplate.memberIdTags.length===0">请点击选择使用员工</span>
                                        <el-tag
                                                v-for="(tagCell, tagCellIndex) in businessCardTemplate.memberIdTags"
                                                :key="tagCellIndex"
                                                size="mini"
                                                @close="handleCloseOrganization(tagCellIndex,tagCell.id)"
                                                closable
                                        >{{ tagCell.name }}</el-tag
                                        >
                                    </div>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="个人信息">
                            <el-alert
                                title="个人信息将跟随管理系统中，企业管理-员工管理中的员工信息。如需修改请前往。"
                                type="info"
                                :closable="false">
                            </el-alert>
                        </el-form-item>
                        <el-form-item label="智能助理">
                            <el-select v-model="businessCardTemplate.askBotApiKey" placeholder="请关联智能助理">
                            <el-option :label="bot.name" :value="bot.apiKey" 
                            v-for="(bot) in allBotInfos" :key="bot.apiKey"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                  </div>
            </div>
            <div class="business-card-template-preview">
                <div class="business-card-template-preview-content">
                    <div class="card-box">
                        <div class="user-base-info">
                            <div class="user-base-info-text">
                                <span class="name">王小帅</span>
                                <span>高级销售经理</span>
                                <span>北京果然智汇科技有限公司</span>
                            </div>
                            <div class="user-base-info-img">
                                <image src="../../assets/images/touxiang.jpg"></image>
                            </div>
                        </div>
                        <div class="user-more-info">
                            <div class="user-more-info-item">
                                <i class="arsenal_icon arsenaldianhua"></i>
                                <span>13910002222</span>
                            </div>
                            <div class="user-more-info-item">
                                <i class="arsenal_icon arsenalemail"></i>
                                <span>wangxiaoshuai@guoranbot.com</span>
                            </div>
                            <div class="user-more-info-item">
                                <i class="arsenal_icon arsenalweizhi"></i>
                                <span>北京市海淀区中关村微软大厦2号楼加速器</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-operation-box">
                        <div class="card-operation-item">
                            <span class="count">200人看过</span>
                        </div>
                        <div class="card-operation-item share">
                            <button type="default" open-type="share"><i class="arsenal_icon arsenalshare-square"></i>分享</button>
                        </div>
                    </div>
                    <div class="chatbot-box">
                        <div class="chatbot-title gray">
                            <div class="chatbot-title-text">智能助理</div>
                        </div>
                        <div class="chatbot-content">
                            <div class="message-box">
                                <div class="chatbot-message">
                                    <p>您好，我是王小帅的智能助理，请问您是为企业咨询还是个人兴趣？</p>
                                </div>
                            </div>
                            <div class="message-box-user">
                                <div class="user-message">
                                    <p>单位</p>
                                </div>
                            </div>
                            <div class="message-box">
                                <div class="chatbot-message">
                                    <p>您打算在什么场景下使用呢？</p>
                                </div>
                            </div>
                            <div class="message-box-user">
                                <div class="user-message">
                                    <p>公司IT部门</p>
                                </div>
                            </div>
                            <div class="message-box">
                                <div class="chatbot-message">
                                    <p>公司大概有多少人使用呢？</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="business-card-template-footer">
            <el-button @click="templateConfigDrawer=false">取 消</el-button>
            <el-button type="primary" @click="saveCardTemplate" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
        </div>
    </el-drawer>
      <el-dialog
              title="选择成员"
              :visible.sync="memberDialogTableVisible"
              :close-on-click-modal="false"
              width="600px"
              append-to-body
      >
          <div  class="bind-bot-self-tree">
              <member-tree
                      :assignType="checkMemberTree"
                      :memberListShow="members"
                      ref='memberTree'
              ></member-tree>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button @click="memberDialogTableVisible = false">取 消</el-button>
              <el-button type="primary" @click="memberDialog">确 定</el-button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import MemberTree from "../../components/memberTree";
import {showParent} from "@/assets/js/getChildrenLeng";
export default {
    components: {MemberTree},
    data(){
        return{
            tableData: [],
            allBotInfos:[],
            members:[],
            businessCardTemplate:{
                id:'',
                name:'',
                askBotApiKey:'',
                memberIdList:[],
                memberIdTags:[]
            },
            loading:false,
            templateConfigDrawer: false,
            memberDialogTableVisible:false,
            checkMemberTree:'checkMemberTree',
            cardTitle:'添加模板'
        }
    },
    methods:{
        onTemplateEdit(row){
            this.templateConfigDrawer = true;
            console.debug('onTemplateEdit',row);
            this.businessCardTemplate.id = row.id;
            this.businessCardTemplate.askBotApiKey = row.askBotApiKey;
            this.businessCardTemplate.memberIdList=[];
            this.businessCardTemplate.memberIdTags=[]
            if (row.originSelectIds){
              this.seachSelectUserIds(this.members,row.originSelectIds)
            }
            this.businessCardTemplate.name = row.name;
            console.debug('onTemplateEdit',this.businessCardTemplate);
            let obj = {};

            let peon = this.businessCardTemplate.memberIdList.reduce((cur,next) => {
                obj[next.id] ? "" : obj[next.id] = true && cur.push(next);
                return cur;
            },[])
            this.businessCardTemplate.memberIdList=peon
            if (this.businessCardTemplate.memberIdList.length > 0){
                this.businessCardTemplate.memberIdList.forEach(item=>{
                    if (item.isMember){
                        this.businessCardTemplate.memberIdTags.push(item)
                    }
                })
            }
            this.cardTitle='编辑模板'
            console.log('businessCardTemplate.memberIdList',peon)
        },
        //通知模板使用者
        notifyUser(item){
            console.log(item)
            let url='/scrm-api/business-card-template/notify/'+item.id;
            this.$http.put(url).then(res=>{
                console.log(res)
                this.$message({
                    message:'通知成功',
                    type:'success',
                    duration:2000
                })
            })
        },
        /*遍历人员信息*/
        seachSelectUserIds(value,ids){
            if (value!==null){
                if (ids){
                    for (let i=0;i<value.length;i++){
                        if (ids.indexOf(value[i].id)!==-1){
                            this.businessCardTemplate.memberIdList.push(value[i])
                            this.seachSelectUserIds(value[i].children,ids)
                        }
                        else {
                            this.seachSelectUserIds(value[i].children,ids)
                        }
                    }
                }


            }
            else
                return

        },
        openBusinessCardTemplate(){
            this.templateConfigDrawer = true;
            this.businessCardTemplate.id=''
            this.businessCardTemplate.askBotApiKey=''
            this.businessCardTemplate.memberIdList=[]
            this.businessCardTemplate.memberIdTags=[]
            this.businessCardTemplate.name=''
            this.cardTitle='添加模板'
        },
        deleteTemplate(id){
            this.$confirm('确定删除模板, 是否继续?', '删除模板', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.delete('/scrm-api/business-card-template/'+id)
                    .then(response=>{
                        console.debug('delete business card',response.data);
                        this.loadCardsData();
                    }).finally(()=>{
                    this.loading = false;
                })
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除',
                    duration:2000
                });
            });

        },
        clickTr(row){
            //console.log(row["id"]) 跟下面效果一样
            console.log(row.id)//获取各行id的值
        },
        loadCardsData(){
            this.$http.get('/scrm-api/business-card-template/dto')
            .then(response=>{
                console.debug('card templates',response.data);
                this.tableData = response.data;
                this.tableData.reverse()
            })
        },
        loadBotInfos(){
            this.$http.get('/scrm-api/intermediate/bot-infos')
            .then(response=>{
                console.debug('card templates',response.data);
                this.allBotInfos = response.data;
            })
        },
        loadMemberInfo(){
            this.$http.get('/scrm-api/we-work/member')
            .then(response=>{
                console.debug('member info',response.data);
                this.members = response.data;
              this.setAttr4MemberList(this.members,(item)=>{
                this.$set(item,'checked',false);
              })
            })
        },
        saveCardTemplate(){
            console.debug('saveCardTemplate',this.businessCardTemplate);
            let weWorkMemberIds = this.businessCardTemplate.memberIdList.filter((item)=>item.isMember==true).map((member)=>member.id)
          let originSelectIds = this.businessCardTemplate.memberIdList.map((member)=>member.id)
            if (this.businessCardTemplate.name===''){
                this.$message({
                    message:'模版名称不能为空',
                    duration:2000,
                    type:'warning'
                })
                return
            }
            console.log(this.businessCardTemplate.memberIdList.length)
            if (weWorkMemberIds.length === 0){
                this.$message({
                    message:'请选择使用员工',
                    duration:2000,
                    type:'warning'
                })
                return
            }
            if (this.businessCardTemplate.askBotApiKey===''){
                this.$message({
                    message:'请选择关联智能助理',
                    duration:2000,
                    type:'warning'
                })
                return
            }
            let businessCardTemplate={
                askBotApiKey:this.businessCardTemplate.askBotApiKey,
                originSelectIds:originSelectIds,
                weWorkMemberIds:weWorkMemberIds,
                name:this.businessCardTemplate.name,
                id:this.businessCardTemplate.id
            }
            console.log(businessCardTemplate)
            if(this.businessCardTemplate.id===''){
                this.loading = true;
                // 新增模板
                this.$http.post('/scrm-api/business-card-template',businessCardTemplate)
                    .then(response=>{
                        console.debug('add business card',response.data);
                        this.$message({message: '新增模板成功',type: 'success'});
                        this.templateConfigDrawer = false;
                        this.loadCardsData();
                    }).finally(()=>{
                    this.loading = false;
                })
            }
            else{
                // 更新模板
                this.loading = true;
                this.$http.put('/scrm-api/business-card-template/'+this.businessCardTemplate.id,businessCardTemplate)
                    .then(response=>{
                        console.debug('update business card',response.data);
                        this.$message({message: '更新模板成功',type: 'success'});
                        this.templateConfigDrawer = false;
                        this.loadCardsData();
                    }).finally(()=>{
                    this.loading = false;
                })
            }
        },
      setAttr4MemberList(list, setAttrFun) {
        if (setAttrFun == null) {
          return list;
        }
        if (list !== null) {
          list.forEach(item => {
            setAttrFun(item);
            this.setAttr4MemberList(item.children, setAttrFun)
          })
        } else
          return list
      },
        setActiveTreeIndex() {
            console.log('123')
            /*  this.showTree=!this.showTree*/
            this.memberDialogTableVisible=true
            let arr = [];
            this.businessCardTemplate.memberIdList.forEach((item) => {
                arr.push(item.id);
            })
            console.log('setActiveTreeIndex memberIdList',arr)
            setTimeout(() => {
                this.initShowOrTree(arr, true, "init");
                setTimeout(()=>{
                  showParent(this.businessCardTemplate.memberIdList,0)
                  this.$refs.memberTree.memberIdList = this.businessCardTemplate.memberIdList
                },100)
            }, 100);
        },
        handleCloseOrganization(tagCellIndex,id) {
            this.initShowOrTree([id], false, "close");
            if (this.businessCardTemplate.memberIdList.length > 0){
                this.businessCardTemplate.memberIdList.forEach((item,index)=>{
                    if (item.id===id){
                        this.businessCardTemplate.memberIdList.splice(index, 1);
                      /*  this.businessCardTemplate.memberIdTags.splice(index,1)*/
                    }
                })
            }
          if (this.businessCardTemplate.memberIdTags.length > 0){
            this.businessCardTemplate.memberIdTags.forEach((item,index)=>{
              if (item.id===id){
                  this.businessCardTemplate.memberIdTags.splice(index,1)
              }
            })
          }

        },
        initShowOrTree(handleIdArr, isChecked, type) {
            const formOrgTree = (arr, handleIdArr, isChecked) => {
                if (type == "close") {
                    arr.forEach((item) => {
                        if (handleIdArr.indexOf(item.id) != -1) {
                            item.checked = isChecked;
                            if (item.children) {
                                formOrgTree(item.children, handleIdArr, isChecked);
                            }
                        } else {
                            if (item.children) {
                                formOrgTree(item.children, handleIdArr, isChecked);
                            }
                        }
                    });
                } else {
                    arr.forEach((item) => {
                        if (handleIdArr.indexOf(item.id) != -1) {
                            item.checked = isChecked;
                            if (item.children) {
                                formOrgTree(item.children, handleIdArr, isChecked);
                            }
                        } else {
                            item.checked = !isChecked;
                            if (item.children) {
                                formOrgTree(item.children, handleIdArr, isChecked);
                            }
                        }
                    });
                }

                return arr;
            };
            this.members= [
                ...formOrgTree(this.members, handleIdArr, isChecked),
            ];
        },
        memberDialog(){
            this. memberDialogTableVisible = false
            this.businessCardTemplate.memberIdTags=[]
            this.$nextTick(()=>{
                console.log('memberDialog memberIdList',this.$refs.memberTree.memberIdList)
                this.businessCardTemplate.memberIdList=this.$refs.memberTree.memberIdList
                if (this.$refs.memberTree.memberIdList&&this.$refs.memberTree.memberIdList.length > 0){
                    this.$refs.memberTree.memberIdList.forEach(item=>{
                        if (item.isMember){
                            this.businessCardTemplate.memberIdTags .push(item)
                        }
                    })
                }

            })
        },
    },
    mounted(){
         this.loadCardsData();
         this.loadBotInfos();
         this.loadMemberInfo();
    },
  watch:{

  }
}
</script>

<style lang="less" scoped>
@import url(../../assets/less/leadsSource/businessCard.less);
.bind-bot-self-tree{
    max-height: calc(100vh - 370px);
    min-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
}
.bind-bot-self-tree-box {
    text-align: left;
    flex: auto;
    position: relative;
    line-height: 28px;
    height: 56px;
    padding: 0;
    .selected-box {
        border: solid 1px #e4e7ed;
        height: 56px;
        overflow-y: auto;
        display: flex;
        justify-content: space-between;

        .tag-box {
            height: 56px;
            flex: auto;
            .placeholder {
                height: 56px;
                line-height: 56px;
                color: #c0c4cc;
                margin-left: 8px;
            }
            .el-tag {
                margin-left: 6px;
            }
        }
        .handle-teg-box {
            flex: none;
            width: 15px;
            margin-left: 10px;
            line-height: 100%;
            cursor: pointer;
            position: absolute;
            right: 1px;
            top: 20px;
            span {
                height: 10px;
                flex: none;
            }
        }
    }
    .bind-bot-self-tree {
        padding-top: 5px;
        padding-left: 6px;
        z-index: 99999999999999999;
        position: relative;
        top: 3px;
        background-color: white;
        border-left: solid 1px #e4e7ed;
        border-right: solid 1px #e4e7ed;
        border-bottom: solid 1px #e4e7ed;
        border-radius: 6px;
        overflow: auto;
    }
}
</style>